import { isWorkablePendingWorkspaceClient } from "../../invitations/pendingWorkspaceState";

const ACTIVE_CLIENT_STATUS = "active-string";

const normalizeStatus = (value) =>
  typeof value === "string" ? value.trim() : "";

const isActiveClient = (client) =>
  normalizeStatus(client?.status) === ACTIVE_CLIENT_STATUS;

const toClientArray = (clients) => (Array.isArray(clients) ? clients : []);

const buildPendingMetrics = (clients = []) => {
  const totalCount = clients.length;
  const checkedCount = clients.filter((client) => client?.isChecked === true).length;
  const pendingCount = clients.filter((client) => client?.isChecked === false).length;

  return {
    totalCount,
    checkedCount,
    pendingCount,
    progress: totalCount > 0 ? checkedCount / totalCount : 0,
  };
};

const isPendingNewBlockClient = (client) =>
  client?.getBlockWeeks === client?.getBlockCurrentWeek;

const isPendingBlockUpdateClient = (client) =>
  client?.getBlockWeeks != client?.getBlockCurrentWeek;

export const isDashboardSummaryCardClient = (client) => {
  if (!client || typeof client !== "object") {
    return false;
  }

  return isActiveClient(client) || isWorkablePendingWorkspaceClient(client);
};

export const selectDashboardSummaryCardClients = (clients = []) =>
  toClientArray(clients).filter((client) => isDashboardSummaryCardClient(client));

export const getPendingAthletesCardMetrics = (clients = []) =>
  buildPendingMetrics(selectDashboardSummaryCardClients(clients));

export const getPendingNewBlockCardMetrics = (clients = []) =>
  buildPendingMetrics(
    selectDashboardSummaryCardClients(clients).filter((client) =>
      isPendingNewBlockClient(client)
    )
  );

export const getPendingBlockUpdateCardMetrics = (clients = []) =>
  buildPendingMetrics(
    selectDashboardSummaryCardClients(clients).filter((client) =>
      isPendingBlockUpdateClient(client)
    )
  );
